import { useDashboardFolderHeaderModel } from './dashboard-folder-header.model'
import { DashboardFolderHeaderView } from './dashboard-folder-header.view'

export const DashboardFolderHeader = () => {
  const dashboardFolderHeaderModel = useDashboardFolderHeaderModel()
  return <DashboardFolderHeaderView {...dashboardFolderHeaderModel} />
}
